import script from "./LoginPageDeveloper.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginPageDeveloper.vue?vue&type=script&setup=true&lang=ts"

import "./LoginPageDeveloper.vue?vue&type=style&index=0&id=194c3c18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-194c3c18"]])

export default __exports__